//import angular from 'angular';
import tmpl from './laterThen.html';


angular.module('amtFramework.validation').directive('laterThen',
    ['$filter', '$parse', '$compile', 'amtXlatSvc',
        function ($filter, $parse, $compile, amtXlatSvc) {
            return {
                require: 'ngModel',
                link: function (scope: any, elem, attrs, ctrl) {
                    var valSpan = angular.element(tmpl);
                    valSpan.insertAfter(elem);
                    $compile(valSpan)(scope);
                    ctrl.$parsers.unshift(function (value) {
                        return validate(value);
                    });

                    scope.$watch(attrs.laterThen, function () {
                        validate(ctrl.$modelValue);
                    });

                    var validate = function (value) {
                        var getter = $parse(attrs.laterThen);
                        var comparisonValue = getter(scope);
                        var compareMessageValue = '';
                        var equalGetter = $parse(attrs.equal);
                        var isEqual = equalGetter(scope);

                        if (value === undefined || value === null || comparisonValue === undefined || comparisonValue === null) {
                            // It's valid because we have nothing to compare against
                            ctrl.$setValidity('laterThen', true);
                            scope.laterThenValid = true;
                            return value;
                        }

                        // It's valid if model is later than the model we're comparing against
                        var valid = true;
                        if (value.getYear) {
                            if (comparisonValue.getYear) {
                                valid = value > comparisonValue;
                                if (isEqual) {
                                    valid = value >= comparisonValue;
                                }
                                compareMessageValue = comparisonValue.toString();
                            }
                            if (comparisonValue.year && comparisonValue.month) {
                                var comparisonDateValue = new Date(comparisonValue.year, comparisonValue.month - 1, 1);
                                valid = value > comparisonDateValue;
                                if (isEqual) {
                                    valid = value >= comparisonDateValue;
                                }
                                compareMessageValue = $filter('monthYear')(comparisonDateValue);
                            }
                        }
                        if (!isNaN(value) && !isNaN(comparisonValue)) {
                            valid = value > comparisonValue;
                            if (isEqual) {
                                valid = value >= comparisonValue;
                            }
                            compareMessageValue = comparisonValue;
                        }
                        ctrl.$setValidity('laterThen', valid);
                        setUiValidation(valid);

                        scope.laterThenValid = valid;
                        scope.validationLaterThenMessage = amtXlatSvc.xlat("common.validationEarlierThen_message", compareMessageValue);

                        return value;
                    };

                    function setUiValidation(valid) {
                        var datePickerElement = angular.element(elem).parent();
                        if (!valid) {
                            angular.element(datePickerElement).addClass('ng-invalid');
                        }
                        else {
                            angular.element(datePickerElement).removeClass('ng-invalid');
                        }
                    }
                }
            };
        }
    ]
);
